import * as bowser from 'bowser';
import { Injectable } from '@angular/core';

@Injectable()
export class BrowserVendorService {
  /**
   * @ngdoc method
   * @name opera
   * @methodOf BrowserVendorService
   * @returns {boolean} - is the current browser opera?
   */
  public get opera(): boolean {
    return bowser.opera;
  }
  /**
   * @ngdoc method
   * @name firefox
   * @methodOf BrowserVendorService
   * @returns {boolean} - is the current browser firefox?
   */
  public get firefox(): boolean {
    return bowser.firefox;
  }
  /**
   * @ngdoc method
   * @name safari
   * @methodOf BrowserVendorService
   * @returns {boolean} - is the current browser safari?
   */
  public get safari(): boolean {
    return bowser.safari;
  }
  /**
   * @ngdoc method
   * @name chrome
   * @methodOf BrowserVendorService
   * @returns {boolean} - is the current browser chrome?
   */
  public get chrome(): boolean {
    return bowser.chrome;
  }
  /**
   * @ngdoc method
   * @name msie
   * @methodOf BrowserVendorService
   * @returns {boolean} - is the current browser IE?
   */
  public get msie(): boolean {
    return bowser.msie;
  }
  /**
   * @ngdoc method
   * @name mobile
   * @methodOf BrowserVendorService
   * @returns {boolean} - is the current browser a mobile browser?
   */
  public get mobile(): boolean {
    return bowser.mobile || bowser.tablet;
  }

  /**
   * @ngdoc method
   * @name name
   * @methodOf BrowserVendorService
   * @returns {string} the current browser name
   */
  public get name(): string {
    return bowser.name && bowser.name.toLowerCase();
  }

  /**
   * @ngdoc method
   * @name classes
   * @methodOf BrowserVendorService
   * @returns {string} a class or list of classes that correspond to the current browser
   */
  public get classes(): string {
    return `${this.name} ${this.mobile ? 'mobile' : ''}`;
  }

  /**
   * @ngdoc method
   * @name gradeA
   * @methodOf BrowserVendorService
   * @returns {boolean} is this a grade A browser?
   */
  public get gradeA(): boolean {
    return bowser.a;
  }

  /**
   * @ngdoc method
   * @name gradeC
   * @methodOf BrowserVendorService
   * @returns {boolean} is this a grade C browser?
   */
  public get gradeC(): boolean {
    return bowser.c;
  }
}